import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { IUserLevelCoupon } from "@/api_framework/api_modals/coupon";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

// Lists user-level copies created by the logged-in staff today.
export const useUserLevelCouponListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [coupons, setCoupons] = useState<IUserLevelCoupon[]>([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(COUPON_SERVICE_APIS?.USER_LEVEL_COUPON?.baseURL, {
          headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" },
        })
        .then((res: AxiosResponse<{ status: boolean; data: IUserLevelCoupon[] }>) => {
          setCoupons(res.data?.status ? res.data?.data ?? [] : []);
        })
        .catch((e: AxiosError) => {
          setCoupons([]);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, []);

  return { execute, coupons, setCoupons };
};
